import angular from 'angular';
import findCheckDialogTemplate from './findCheckDialog.html';

/*****************************************************************************
 * Service: FindCheckDialog
 *
 * Utility to display a dialog to search for checks
 *****************************************************************************/
/* @ngInject */ export function FindCheckDialogService(
  $uibModal,
  uiGridConstants,
  BooksSettings
) {
  /** Instance Reference. */
  var mSelf = this;

  /*-----------------*/
  /* Persistent Data */
  /*-----------------*/
  /** Found Checks. */
  mSelf.foundChecks = [];

  var mPaidTo;

  /** Saved Filters. */
  var mSavedFilters;

  /*-----------------------------------------*/
  /* template to add ng-dblClick to each row */
  /*-----------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.viewCheck(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /** Dialog Controller. */
  var FindChecksController = function (
    $q,
    $scope,
    Alert,
    Tools,
    BooksSettings,
    BooksSvc,
    BusyScreen,
    banks,
    SERVER
  ) {
    /* Generic data object. */
    $scope.data = {};

    /** Bank account validator. */
    $scope.bankVal = {};

    /*---------------*/
    /* Dataproviders */
    /*---------------*/
    $scope.bankList = banks;

    /*------------------*/
    /* Find Grid Config */
    /*------------------*/
    $scope.findGridOptions = {
      enableColumnMenus: false,
      enableSorting: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableRowHeaderSelection: true,
      enableFullRowSelection: true,
      multiSelect: false,
      onRegisterApi: function (gridApi) {
        $scope.findGridOptions.api = gridApi;
      },
      rowTemplate: dblClickTemplate,
      columnDefs: [
        {
          field: 'entryDate',
          maxWidth: 120,
          cellFilter: "date: 'MM/dd/yyyy'",
          displayName: 'Date',
          type: 'date',
          filterCellFiltered: true
        },
        {
          field: 'number',
          maxWidth: 120,
          labelFunction: function (check) {
            return check.handwritten
              ? check.checkNumber + 'h'
              : check.checkNumber == 0
                ? ''
                : check.checkNumber;
          }
        },
        { field: 'paidTo' },
        {
          field: 'amount',
          maxWidth: 120,
          cellFilter: 'currency',
          type: 'number'
        },
        {
          field: 'status',
          maxWidth: 120,
          labelFunction: function (check) {
            return check.cleared
              ? 'Cleared'
              : check.voided
                ? 'Void'
                : check.printed
                  ? 'Printed'
                  : check.checkNumber == 0
                    ? 'To Print'
                    : '';
          }
        }
      ],
      data: mSelf.foundChecks
    };

    /*****************************************************************************
     * checkNumber */
    /**
     * getterSetter for the check number filter. The value will be rounded to the
     * nearest whole number when valid.
     *****************************************************************************/
    $scope.checkNumber = function (value) {
      if (arguments.length) {
        if (!value) $scope.filters.checkNumber = null;
        else if (!isNaN(value)) {
          $scope.filters.checkNumber = Tools.roundToPrecision(value, 0);
          $scope.filters.startDate = null;
        }
      } else return $scope.filters.checkNumber;
    };

    /*****************************************************************************
     * checkSelected */
    /**
     * Returns an indication that a check has been selected.
     *****************************************************************************/
    $scope.checkSelected = function () {
      return $scope.findGridOptions.api?.selection.getSelectedCount() > 0;
    };

    /*****************************************************************************
     * clear */
    /**
     * Reset the filters and remove any currently found checks
     *****************************************************************************/
    $scope.clear = function () {
      $scope.findGridOptions.api?.selection.clearSelectedRows();
      $scope.findGridOptions.data = mSelf.foundChecks = [];
      newFilters();
      $scope.filters.startDate = null;
      $scope.data.entity = null;
    };

    /*****************************************************************************
     * endAmt */
    /**
     * getterSetter for the ending check amount. Ensures only numeric values are
     * used.
     *****************************************************************************/
    $scope.endAmt = function (value) {
      if (arguments.length) {
        if (!value) $scope.filters.endAmt = NaN;
        else if (!isNaN(value))
          $scope.filters.endAmt = Tools.roundToPrecision(value, 2);
      } else return $scope.filters.endAmt;
    };

    /***************************************************************************
     * getEntities */
    /**
     * Returns a list of entities that match the given text.
     *
     * @param   text   Current input text
     * @return         Array of sorted corresponding matching entities
     ***************************************************************************/
    $scope.getEntities = function (text) {
      var defer = $q.defer();
      BooksSvc.findAddressEntities(
        text,
        BooksSettings.ledgerEntityTypes(),
        true
      ).then(function (resp) {
        defer.resolve(resp.data);
      });
      return defer.promise;
    };

    /*****************************************************************************
     * newFilters */
    /**
     * Reset the check filters and clear any saved filters.
     *****************************************************************************/
    function newFilters() {
      $scope.filters = {
        bankAccountID: null,
        checkNumber: null,
        entityID: null,
        paidTo: null,
        startAmt: NaN,
        endAmt: NaN,
        startDate: Tools.lastFiscalYearStart(
          SERVER.BooksOrgInfo.fyMonth,
          SERVER.BooksOrgInfo.fyDay
        ),
        endDate: null
      };
      mSavedFilters = null;
    }

    /*****************************************************************************
     * paidTo */
    /**
     * Getter/setter for the Paid To entity.
     *
     * @return   AddressEntityListItem object
     *****************************************************************************/
    $scope.paidTo = function (addressEntity) {
      if (arguments.length == 0) return mPaidTo;

      mPaidTo = addressEntity;
      $scope.filters.entityID = angular.isObject(addressEntity)
        ? addressEntity.entity.id
        : null;
    };

    /*****************************************************************************
     * paidToLabelFunction */
    /**
     * Maintain a reference to the the addressEntity label function to be used in
     * the Paid To typeahed.
     *****************************************************************************/
    $scope.paidToLabelFunction = BooksSettings.entityAddressItemLabel;

    /***************************************************************************
     * printCheckCopy */
    /**
     * Print a copy of the selected check in a new window.
     ***************************************************************************/
    $scope.printCheckCopy = function () {
      var check = $scope.findGridOptions.api?.selection.getSelectedRows()[0];

      window.open('PrintCheckCopy.ashx?ChecksToPrint=' + check.id);
    };

    /*****************************************************************************
     * search */
    /**
     * Attempts to find checks corresponding to the current filters.
     *****************************************************************************/
    $scope.search = function () {
      if (!$scope.bankVal.validate()) return;

      BusyScreen.setBusy(true);
      BooksSvc.findChecks($scope.filters)
        .then(function (resp) {
          $scope.findGridOptions.api?.selection.clearSelectedRows();

          /*---------------------------------*/
          /* Save filters and search results */
          /*---------------------------------*/
          $scope.findGridOptions.data = mSelf.foundChecks = resp.data;
          mSavedFilters = $scope.filters;

          if (mSelf.foundChecks.length == 0)
            Alert.info('No checks were found', 'No Checks Found');
          else if (mSelf.foundChecks.length == 1)
            $scope.viewCheck(mSelf.foundChecks[0]);
        })
        .catch(function (error) {
          Alert.error(
            error.parsedResponse?.message() ||
              'Failed to pull up checks. Please try again.',
            'Find Checks Error'
          );
        })
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    };

    /*****************************************************************************
     * startAmt */
    /**
     * getterSetter for the starting check amount. Called on blur. Ensures only
     * numeric values are used.
     *****************************************************************************/
    $scope.startAmt = function (value) {
      if (arguments.length) {
        if (!value) $scope.filters.startAmt = NaN;
        else if (!isNaN(value))
          $scope.filters.startAmt = Tools.roundToPrecision(value, 2);
      } else return $scope.filters.startAmt;
    };

    /*****************************************************************************
     * viewCheck */
    /**
     * Resolve promise with passed check object or the selected check.
     *****************************************************************************/
    $scope.viewCheck = function (check) {
      if (!check)
        check = $scope.findGridOptions.api?.selection.getSelectedRows()[0];

      $scope.$close(check);
    };

    /*-------------------------------------------*/
    /* If a search was previously performed,     */
    /* prepopulate fields with the last filters. */
    /*-------------------------------------------*/
    if (mSavedFilters) $scope.filters = mSavedFilters;
    else newFilters();
  };

  /*****************************************************************************
   * reset */
  /**
   * Clear the saved filters and remove any found checks.
   *****************************************************************************/
  this.reset = function () {
    mSavedFilters = null;
    mPaidTo = null;
    mSelf.foundChecks = [];
  };

  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog to provide a means to search for checks.
   *
   * @param  banks      List of bank accounts
   * @param  entities   List of entities to search against
   * @return            Promise to listen on
   *****************************************************************************/
  this.show = function (banks) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      resolve: {
        banks: function () {
          return banks;
        }
      },
      controller: FindChecksController,
      size: 'lg',
      template: findCheckDialogTemplate
    }).result;
  };
}
